<template>
  <div class="row mb-16">
    <div class="small-12 columns">
      <div class="m-6 flex items-center justify-between">
        <div class="mr-5">
          <router-link
            class="border mb-0 p-2 px-12 rounded-full bg-green text-white font-bold no-underline"
            to="/join-link"
          >
            Add Link
          </router-link>
        </div>
        <h1 class="mr-16">Join Links</h1>
        <div class="flex items-center">
          <h3 class="inline mr-5">Filters</h3>
          <input
            id="active-only"
            v-model="active"
            type="checkbox"
            @input="updateRoute($event, 'active')"
          />
          <label for="active-only" class="ml-1 mr-5 mb-0 p-0"
            ><b>active</b></label
          >
        </div>
      </div>
      <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      active: true,
      joinLinks: [],

      endpoint: `${siteConfig.siteURL}admin/join_links?fields=id,name,updated_on,cohort_id,cohort,meta,is_enabled,emails_are_restricted,institution_tags_are_restricted`,

      tableConfig: [
        {
          header: { textContent: "Active" },
          path: "is_enabled",
          formatter: is_enabled => (is_enabled ? "✅" : "❌"),
        },
        {
          header: { textContent: "Name/Link" },
          path: "/",
          formatter: ({ name }) =>
            `<a target="_blank" href="https://edyst.com/join/${name}">/join/${name}</a>`,
        },
        {
          header: { textContent: "Title" },
          path: "meta.title",
        },
        {
          header: { textContent: "Cohort" },
          path: "/",
          formatter: ({ cohort: { name, id } }) =>
            `<a target="_blank" href="/cohort-edit/${id}">${name}</a><br><small>${id}</small>`,
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Restrict By" },
          path: "/",
          formatter: this.getRestrictedValues,
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/join-link/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
  created() {
    const searchParams = new URLSearchParams("active=true")
    const newRouteObj = { ...this.$route, query: { ...this.$route.query } }
    searchParams.forEach((value, key) => {
      newRouteObj.query[key] = value
    })
    this.$router.replace(newRouteObj)
  },
  methods: {
    getRestrictedValues(join_link) {
      let restrictByValues = ""
      if (join_link.institution_tags_are_restricted) {
        restrictByValues += "Institutions,<br/>"
      }
      if (join_link.emails_are_restricted) {
        restrictByValues += "Email,<br/>"
      }
      return restrictByValues.length > 0 ? restrictByValues : "--"
    },
    updateRoute(event, key) {
      const data = { key, value: event.target.checked }
      this.$refs.myTable.updateRoute(data)
    },
  },
}
</script>

<style lang="postcss"></style>
